var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('admin-layout',[_c('lists',{attrs:{"slot":"content"},slot:"content"})],1):_c('in-layout',[_c('lists',{staticClass:"mt-3",attrs:{"slot":"content"},slot:"content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }